module.exports = __webpack_public_path__ + "static/result_cheonan-42a0b27e081ca7dad2ab9625ab987682.png";